export default {"src":"/_next/static/media/main.fd1bcf44.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};